export const claimEncounterColumns = [
  'r1_id',
  'account_number',
  'facility_npi',
  'billing_provider_id',
  'claim_number',
  'subscriber_first_name',
  'subscriber_last_name',
  'subscriber_middle_name',
  'subscriber_code',
  'subscriber_dob',
  'subscriber_gender',
  'subscriber_addr_street',
  'subscriber_addr_city',
  'subscriber_addr_state',
  'subscriber_addr_zip',
  'subscriber_group_policy_id',
  'subscriber_payer_name',
  'payer_name',
  'payer_id_type',
  'payer_addr_street',
  'payer_addr_city',
  'payer_addr_state',
  'payer_addr_zip',
  'secondary_payer_name',
  'secondary_payer_plan_id',
  'secondary_payer_plan_code',
  'interchange_control_number',
  'interchange_generated_date',
  'interchange_generated_time',
  'claim_facility_and_freq_code',
  'admission_date_434',
  'discharge_date_434',
  'admission_type',
  'admission_source',
  'discharge_status',
  'doc_control_num',
  'patient_mrn',
  'total_claim_amount',
  'estimated_amount_due',
  'prior_payments',
];
